import * as React from 'react';
import { colors } from '../../../index';

const IconExit = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 53 53",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.08 19.38A1 1 0 0034 20h12a1 1 0 000-2h-9.59l16.3-16.3A1 1 0 1051.29.3L35 16.58V7a1 1 0 00-2 0v12c0 .13.03.26.08.38zM1.7 52.7L18 36.42V46a1 1 0 002 0V34a1.01 1.01 0 00-.62-.92A1.01 1.01 0 0019 33H7a1 1 0 000 2h9.59L.29 51.3a1 1 0 101.42 1.4zM19 6a1 1 0 00-1 1v9.58L1.7.3A1 1 0 00.3.3a1 1 0 000 1.42L16.58 18h-9.6a1 1 0 000 2h12a1.01 1.01 0 00.93-.62c.05-.12.08-.25.08-.38V7a1 1 0 00-1-1zm15 41a1 1 0 001-1v-9.6l16.3 16.3a1 1 0 101.4-1.42L36.42 35H46a1 1 0 000-2H34a1.01 1.01 0 00-.92.63c-.05.12-.08.25-.08.38v12a1 1 0 001 1z"
  }));
};

export default IconExit;